module.exports = __webpack_public_path__ + "static/handwerk-f829527f9050fb36ac7d1d3893f58700.jpg";